import '../App.css';
import Introduction from '../components/Introduction';

function Home() {
  return (
    <div>
      <Introduction></Introduction>
    </div>
  );
}

export default Home;
